module.exports = __webpack_public_path__ + "static/logo-ucg-1d417b402f0d5d32c03c8b19bb066336.png";